module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_badge_gold_ghost-b4a0fa02e2b1108a2c74c7dc00a2fc60.svg";